@if (showPage()) {
  <div class="table-container">
    <app-datatable [identifier]="'logs-pkg-table'" [title]="''" [cols]="cols" [rows]="rows" [isloading]="loading" [showcheckboxes]="true"
    [total]="total" (pageevent)="onPageChange($event)" (actionmenuevent)="actionMenuClicked($event)" [isSortable]="false"></app-datatable>
  </div>
} @else {
  <div class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
    <div class="ot-progress__outer">
      <div class="ot-progress__meter"></div>
    </div>
    @if (isLoading && !isManifestUpdating && !isAgentManifestUpdating) {
      <div class="ot-progress__text" i18n>Loading...</div>
    }
    @if (isManifestUpdating) {
      <div class="ot-progress__text" i18n>Please wait while the manifest is updated...</div>
    }
    @if (isAgentManifestUpdating) {
      <div class="ot-progress__text" i18n>Please wait while the Agent manifest is updated...</div>
    }
  </div>
}
